import { useBreakpointValue } from "@chakra-ui/react";

import { TabDesk } from "./tabDesk";
import { TabMobile } from "./tabMobile";

export function TableOr({ children }) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true,
  });

  return (
    <>
      {isWideVersion ? (
        <TabDesk>{children}</TabDesk>
      ) : (
        <TabMobile>{children}</TabMobile>
      )}
    </>
  );
}
